import { useMutation } from '@apollo/client/react';
import { FormattedMessage, useIntl } from 'react-intl';
import { ModalTypography } from 'components/styles_components/typography';
import { useError } from 'contexts/error';
import VerificationForm from 'components/user/two_factor/verification_form';
import DisableMutation from 'mutations/user/two_factor/disable';

const ModalDisable2fa = ({ onSuccess }) => {
  const setError = useError();
  const intl = useIntl();
  const [disableMutation, { loading }] = useMutation(DisableMutation, {
    onCompleted: onSuccess,
    onError: () => {
      setError('error.user.two_factor.disable');
    },
  });

  return (
    <>
      <ModalTypography variant="h5" align="center">
        <FormattedMessage id="header.user.two_factor.disable" />
      </ModalTypography>
      <VerificationForm
        initialValues={{
          code: '',
        }}
        submitLabel={<FormattedMessage id="button.two_factor.disable" />}
        onSubmit={(values, { setFieldError }) => {
          disableMutation({ variables: { code: values.code.toString() } }).catch(() => {
            setFieldError('code', intl.formatMessage({ id: 'error.user.two_factor.disable' }));
          });
        }}
        processing={loading}
      />
    </>
  );
};

export default ModalDisable2fa;
